import React, {Fragment, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {getBase64ImgOnInputChange} from "../../../utilities";
import {errorBox_Show} from "../../../actions/A_Popups";
import {featureInterface} from "./featureInterface";
import {useIsMounted} from "../../../utilities/helperHooks";

const FeaturesSetupFeatureThumbnail = (props) => {

  const {intl, errorBox_Show, feature} = props;
  const {uploadedImageUrl, imageUrl} = feature;
  const [thumbnailLoaded, setThumbnailLoaded] = useState(false);
  const isMounted = useIsMounted();

  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      if (isMounted()) {
        setThumbnailLoaded(true)
      }
    };
    image.onerror = () => {
      if (isMounted()) {
        setThumbnailLoaded(true)
      }
    };
    try {
      image.src = imageUrl;
      if (image.complete) {
        if (isMounted()) {
          setThumbnailLoaded(true)
        }
      }
    } catch (e) {
      if (isMounted()) {
        setThumbnailLoaded(true)
      }
    }
  }, [])

  const onImageLoad = (e) => {
    feature.uploadedImageUrl = e.target.result;
    // updateWizardList(wizardItem);
  };

  const handleUploadChange = (event) => {
    getBase64ImgOnInputChange(event, onImageLoad, errorBox_Show, intl)
  };

  const styles = thumbnailLoaded
    ? uploadedImageUrl || imageUrl ? {backgroundImage: `url(${uploadedImageUrl || imageUrl})`} : null
    : {backgroundImage: `url('')`}

  return (
    <Fragment>
      <label className="wizard-item__thumbnail fs-feature__thumbnail"
             htmlFor={"wizard-item__thumbnail-" + feature.featureDefinitionId}
             style={styles}>
      </label>
      {!thumbnailLoaded ? <div className="ui-loader ui-loader--absolute ui-loader--medium"/> : null}
      <input id={"wizard-item__thumbnail-" + feature.featureDefinitionId}
             type="file"
             className="wizard-upload__input"
             accept="image/png, image/jpeg, image/svg"
             onChange={handleUploadChange}/>
    </Fragment>
  )
};

FeaturesSetupFeatureThumbnail.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = () => {
  // const {wizardPopupGroup} = store.wizardState;
  return {
    // wizardPopupGroup,
  };
};

const mapDispatchToProps = {
  errorBox_Show,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureThumbnail)
)
